import React from 'react'

import {
  TableBodyStyled,
  TableCellStyled,
  TableContainerStyled,
  TableHeadStyled,
  TableRowStyled,
  TableStyled
} from 'components'

import { FORMAT } from 'utils'

// import { Container } from './styles';
interface ITableContract {
  tableData: any[]
}
const TableReportsCurrent: React.FC<ITableContract> = ({ tableData }) => {
  return (
    <TableContainerStyled>
      <TableStyled>
        <TableHeadStyled>
          <TableRowStyled>
            <TableCellStyled align="left">Contrato</TableCellStyled>
            <TableCellStyled align="left">Empresa</TableCellStyled>
            <TableCellStyled align="left">Código Centro</TableCellStyled>
            <TableCellStyled align="left">Centro</TableCellStyled>
            <TableCellStyled align="left">DE</TableCellStyled>
            <TableCellStyled align="left">DIR</TableCellStyled>
            <TableCellStyled align="left">GG</TableCellStyled>
            <TableCellStyled align="left">GER </TableCellStyled>
            <TableCellStyled align="left">Contratada</TableCellStyled>
            <TableCellStyled align="left">SubContratada</TableCellStyled>
            <TableCellStyled align="left">Escopo</TableCellStyled>
            <TableCellStyled align="left">Início</TableCellStyled>
            <TableCellStyled align="left">Fim</TableCellStyled>
            <TableCellStyled align="left">Encerrado</TableCellStyled>
            <TableCellStyled align="left">Contraparte</TableCellStyled>
            <TableCellStyled align="left">Substituto</TableCellStyled>
            <TableCellStyled align="left">Recorrente</TableCellStyled>
            <TableCellStyled align="left">Sócio</TableCellStyled>
            <TableCellStyled align="left">Valor Atual</TableCellStyled>
          </TableRowStyled>
        </TableHeadStyled>
        <TableBodyStyled>
          {tableData?.map((row) => (
            <TableRowStyled key={row}>
              <TableCellStyled align="left">
                {row.cdContrato || '-'}
              </TableCellStyled>
              <TableCellStyled align="left">
                {row.empresa || '-'}
              </TableCellStyled>
              <TableCellStyled align="left">
                {row.cdCentro || '-'}
              </TableCellStyled>
              <TableCellStyled align="left">
                {row.centro || '-'}
              </TableCellStyled>
              <TableCellStyled align="left">{row.de || '-'}</TableCellStyled>
              <TableCellStyled align="left">{row.dir || '-'}</TableCellStyled>
              <TableCellStyled align="left">{row.gg || '-'}</TableCellStyled>
              <TableCellStyled align="left">{row.ger || '-'}</TableCellStyled>
              <TableCellStyled align="left">
                {row.contratada || '-'}
              </TableCellStyled>
              <TableCellStyled align="left">
                {row.subcontratada || '-'}
              </TableCellStyled>
              <TableCellStyled align="left">
                {row.escopo || '-'}
              </TableCellStyled>
              <TableCellStyled align="left">
                {row.inicio || '-'}
              </TableCellStyled>
              <TableCellStyled align="left">{row.fim || '-'}</TableCellStyled>
              <TableCellStyled align="left">{row.encerrado || '-'}</TableCellStyled>
              <TableCellStyled align="left">
                {row.contraparte || '-'}
              </TableCellStyled>
              <TableCellStyled align="left">
                {row.substituto || '-'}
              </TableCellStyled>
              <TableCellStyled align="left">
                {row.recorrente || '-'}
              </TableCellStyled>
              <TableCellStyled align="left">{row.socio || '-'}</TableCellStyled>
              <TableCellStyled align="left">
                {FORMAT.currency(row.valorAtual) || '-'}
              </TableCellStyled>
            </TableRowStyled>
          ))}
        </TableBodyStyled>
      </TableStyled>
    </TableContainerStyled>
  )
}

export default TableReportsCurrent
